/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { PromoteUploadMutationResponse, PromoteUploadPathParams } from "../models/PromoteUpload";

export function getPromoteUploadUrl(id: PromoteUploadPathParams["id"]) {
  const res = { method: 'POST', url: `/upload/${id}/promote` as const }
  return res
}

/**
 * @summary Immediately publish a scheduled upload
 * {@link /upload/:id/promote}
 */
export async function promoteUpload(id: PromoteUploadPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PromoteUploadMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getPromoteUploadUrl(id).url.toString(), ... requestConfig })
  return res.data
}